export enum BooleanOrAny {
  True = 'true',
  False = 'false',
  Any = 'any'
}

export function toggleBooleanOrAny(previousValue: BooleanOrAny | null, value: BooleanOrAny.False | BooleanOrAny.True): BooleanOrAny | null {
  const inverse = value === BooleanOrAny.True ? BooleanOrAny.False : BooleanOrAny.True;

  if (previousValue === BooleanOrAny.Any) {
    return inverse;

  } else if (previousValue === inverse) {
    return BooleanOrAny.Any;

  } else if (previousValue === value) {
    return null;

  }

  return value;
}